export default __webpack_public_path__ + "static/Dasha Kolesnik-dc6cdb9d3d49f34fcd1f089b16bf1ae3.png";